import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const MobileHome: React.FC<CreateIconComponentProps> = (props) => (
  <CreateIconComponent viewBox="0 0 40 40" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.095 15.602L18.762 1.834a1.945 1.945 0 012.476 0l16.667 13.768c.447.37.706.92.706 1.5v19.565c0 1.074-.87 1.944-1.944 1.944H25.556a1.944 1.944 0 01-1.945-1.944v-8.938a3.611 3.611 0 10-7.222 0v8.938c0 1.074-.87 1.944-1.944 1.944H3.332a1.944 1.944 0 01-1.944-1.944V17.1c0-.58.259-1.13.706-1.499zm32.627 2.416L20 5.857 5.278 18.017v16.706H12.5v-6.992a7.5 7.5 0 017.328-7.498L20 20.23a7.5 7.5 0 017.5 7.5v6.993h7.222V18.018z"
    />{' '}
  </CreateIconComponent>
);

export default MobileHome;
